import {
  ADD_RETURN_RO,
  DELETE_RETURN_RO,
  EDIT_RETURN_RO,
  LIST_OF_RETURN_RO,
  RO_RETURN_HISTORY,
  UPDATE_RO_RETURN_STATUS,
  VIEW_RO_RETURN,
  VIEW_SINGLE_RO_RETURN,
} from "./ApiRoutes";
import { authData } from "./services";

export const listOfReturnRO = async (data: object) => {
  const response = await authData.post(LIST_OF_RETURN_RO, data);
  return response?.data;
};

export const deleteROReturn = async (id: number) => {
  const response = await authData.delete(`${DELETE_RETURN_RO}${id}`);
  return response?.data;
};

export const addROReturn = async (data: object) => {
  const response = await authData.post(ADD_RETURN_RO, data);
  return response?.data;
};

export const editROReturn = async (id: number,data: object) => {
  const response = await authData.put(`${EDIT_RETURN_RO}/${id}`, data);
  return response?.data;
};

export const historyOfRoReturn = async (id: number, data: object) => {
  const response = await authData.post(`${RO_RETURN_HISTORY}/${id}`, data);
  return response?.data;
};

export const updateROReturnStatus = async (id: number) => {
  const response = await authData.put(`${UPDATE_RO_RETURN_STATUS}${id}`);
  return response?.data;
};

export const viewRoReturn = async (id: number) => {
  const response = await authData.post(`${VIEW_RO_RETURN}/${id}`);
  return response?.data;
};

export const viewSingleRoReturn = async (id: number) => {
  const response = await authData.post(`${VIEW_SINGLE_RO_RETURN}/${id}`);
  return response?.data;
};
